module.exports = __webpack_public_path__ + "static/media/chart4.df3eaec8.jpg";